<template>
  <div>
    <h1>Hello Vue</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>